import { render, staticRenderFns } from "./HelpDocuments.vue?vue&type=template&id=61598796&scoped=true&"
import script from "./HelpDocuments.vue?vue&type=script&lang=js&"
export * from "./HelpDocuments.vue?vue&type=script&lang=js&"
import style0 from "./HelpDocuments.vue?vue&type=style&index=0&id=61598796&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61598796",
  null
  
)

export default component.exports